import { INVOICE_ITEM_TYPE_OPTIONS } from "@shared/constants";
import { TicketBasketType } from "@shared/modules/basket/types";
import { TicketItemGroupType } from "@shared/modules/item-groups/types/ticket-item-group-type";

export class DataUtils {
  /**
   * Extracts event IDs from ticket items in the basket.
   * This is used for:
   * - Conversion tracking per event
   * - Attribution of ticket sales
   * - Marketing campaign effectiveness measurement
   */
  static getEventIdsFromBasket(basket: TicketBasketType): Array<number> {
    if (!basket.item_groups) {
      return [];
    }
    const ticketItemGroups = basket.item_groups.filter(
      (ig) =>
        ig.item_type === INVOICE_ITEM_TYPE_OPTIONS.INVOICE_ITEM_TYPE_TICKET.id
    );
    if (ticketItemGroups.length > 0) {
      return ticketItemGroups
        .map((tig) => tig.event)
        .filter((value, index, self) => self.indexOf(value) === index);
    }
    return [];
  }

  static getProductIdsFromBasket(basket: TicketBasketType): Array<number> {
    if (!basket.item_groups) {
      return [];
    }
    const productItemGroups = basket.item_groups.filter(
      (ig) =>
        ig.item_type === INVOICE_ITEM_TYPE_OPTIONS.INVOICE_ITEM_TYPE_PRODUCT.id
    );
    if (productItemGroups.length > 0) {
      return productItemGroups
        .map((pig) => pig.product)
        .filter((value, index, self) => self.indexOf(value) === index);
    }
    return [];
  }

  static getMembershipIdsFromBasket(basket: TicketBasketType): Array<number> {
    if (!basket.item_groups) {
      return [];
    }
    const membershipItemGroups = basket.item_groups.filter(
      (ig) =>
        ig.item_type ===
        INVOICE_ITEM_TYPE_OPTIONS.INVOICE_ITEM_TYPE_MEMBERSHIP.id
    );
    if (membershipItemGroups.length > 0) {
      return membershipItemGroups
        .map((mig) => mig.membership_group)
        .filter((value, index, self) => self.indexOf(value) === index);
    }
    return [];
  }

  static getPermissionIdsFromItemGroups(
    itemGroups?: Array<TicketItemGroupType>
  ): Array<number> | undefined {
    if (!itemGroups) {
      return undefined;
    }
    const permissionIds = itemGroups?.flatMap((ig) => [
      ...(ig.tt_seat_permissions ?? []),
      ...(ig.tt_location_permissions ?? []),
    ]);
    return permissionIds.length > 0 ? permissionIds : undefined;
  }
}
